import React,{useState} from 'react';
import {Link} from 'react-router-dom';
import { useStaffData } from '../../../../context/StaffsDataContext';


export const TeacherDetails = () => {

    const { staffData, loading, refreshStaffData } = useStaffData();
    const [currentPage , setCurrentPage] = useState(1);  
    const recordsPage = 8;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;   
        
    let records = [];
    let npage = 0;
    let number = [];
    if(staffData.length > 0){
        npage = Math.ceil(staffData.length / recordsPage);
        records = staffData.slice(firstIndex, lastIndex);
        number = [...Array(npage + 1).keys()].slice(1);
    }

    function prePage (){
        if(currentPage !== 1){
            setCurrentPage(currentPage - 1)
        }
    }
    function changeCPage (id){
        setCurrentPage(id);
    }
    function nextPage (){
        if(currentPage !== npage){
            setCurrentPage(currentPage + 1)
        }
    }
    return (
        <div className="table-responsive basic-tbl">
            <div id="teacher-table_wrapper" className="dataTables_wrapper no-footer">
                <table id="teacher-table" className="tech-data dataTable no-footer" style={{ minWidth: "798px"}}>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Subject</th>
                            <th>Qulification</th>
                            <th>Fee</th>
                            <th className="text-end">Performance</th>
                        </tr>
                    </thead>
                    {records.length > 0
                        ?(
                            <tbody>
                                {records.map((item, ind)=>(
                                    <tr key={ind}>
                                        <td>{item.name}</td>
                                        <td>{item.subject}</td>
                                        <td>{item.qualification}</td>
                                        <td>${item.fee}</td>
                                        <td className="text-end"><span className={`badge badge-sm light badge-${item.status === "Good" ?  'success' : 'danger' }`}>{item.status}</span></td>
                                    </tr>
                                ))}
                                
                            </tbody>
                        )
                        :'No data yet...'
                    }
                </table>
                <div className="d-sm-flex text-center justify-content-between align-items-center">                           
                    <div className='dataTables_info'>
                        Showing {lastIndex-recordsPage + 1} to{" "}
                        {staffData.length < lastIndex ? staffData.length : lastIndex}
                        {" "}of {staffData.length} entries
                    </div>
                    <div
                        className="dataTables_paginate paging_simple_numbers justify-content-center"
                        id="example2_paginate"
                    >
                        <Link
                            className="paginate_button previous disabled"
                            to="#"                                        
                            onClick={prePage}
                        >
                            <i className="fa-solid fa-angle-left" />
                        </Link>
                        <span>                                      
                            {number.map((n , i )=>(
                                <Link className={`paginate_button ${currentPage === n ? 'current' :  '' } `} key={i}                                            
                                    onClick={()=>changeCPage(n)}
                                > 
                                    {n}                                                

                                </Link>
                            ))}
                        </span>
                        <Link
                            className="paginate_button next"
                            to="#"                                        
                            onClick={nextPage}
                        >
                            <i className="fa-solid fa-angle-right" />
                        </Link>
                    </div>
                </div> 
            </div>	
        </div>
    )
}
